export const shadowElevationKeys = ['shadowElevation'];
